// middleware/checkAuth.global.js

import getThemeFromLastLocation from '~/utils/getThemeFromLastLocation';
import {useNuxtApp} from "#imports";

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp();
  const store = nuxtApp.$vuex;
  const $auth = store.state.auth;

  const isThemedLoginRoute = to.name === 'theme-login';
  const isPlainLoginRoute = to.name === 'login';

  const loggedIn = $auth?.loggedIn ?? false;
  const hasTimedOut = $auth?.user?.hasTimedOut ?? false;
  const isRedirectorRoute = to.path === '/redirector';

  if (loggedIn && !hasTimedOut && !isRedirectorRoute) {
    $auth?.$storage?.setUniversal(
      'participantProjectSlugTheme',
      to.params.theme
    );
    return navigateTo('/redirector');
  }

  // 1) Handle redirect-from-logout
  const isFromLogout = from.fullPath.includes('/logout');
  const fromPath= isFromLogout
      ? $auth?.$storage?.getUniversal('redirect')
      : from.fullPath;

  if (fromPath && (isPlainLoginRoute || isThemedLoginRoute)) {
    // stash where we came from
    const redirectTo = fromPath !== '/' ? fromPath : null;
    if(redirectTo){
        sessionStorage.setItem('redirectTo', redirectTo);
    }

    // pick up theme based on previous URL, user prefs, or route param
    const themeFromLastLocation = getThemeFromLastLocation(fromPath);
    const usersTheme =
        $auth?.user?.theme?.slug ||
        themeFromLastLocation ||
        to.params.theme ||
        'app';

    // only run this on client (window.host is undefined on server)
    if (process.client) {
      const domain = window.location.host.split('.')[0];
      if (['dev', 'demo', 'app'].includes(domain)) {
        const themedLoginPath = `/${usersTheme}/login`;
        if (to.path !== themedLoginPath) {
          return navigateTo(themedLoginPath);
        }
      }
    }
  }
});
